<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Early vascular disease in your immediate family is a significant risk factor. 
      Have your father, mother, siblings, or children experienced a premature heart attack, stroke, 
      bypass surgery, or stent? Premature means males having one of these events before age of 55, 
      or females having an event before age of 65.
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.relativeHadHeartAttack">
      <b-form-radio v-model="survey.arteryBlockages.relativeHadHeartAttack" name="family" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.relativeHadHeartAttack" name="family" :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    validations: {
      relativeHadHeartAttack: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      relativeHadHeartAttack() { return this.survey.arteryBlockages.relativeHadHeartAttack; }
    }
  };
</script>